import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from 'hooks/usePermissions';
import { getOrderedRoutes } from 'utils/dashboardPermissions';

const DashboardRedirect = () => {
  const { hasPermission } = usePermissions();

  // Ordem de prioridade dos dashboards (centralizada)
  const dashboardRoutes = getOrderedRoutes();

  // Encontrar o primeiro dashboard que o usuário tem permissão
  const accessibleDashboard = dashboardRoutes.find(route => 
    hasPermission(route.permission)
  );

  // Se encontrou um dashboard acessível, redirecionar para ele
  if (accessibleDashboard) {
    return <Navigate to={accessibleDashboard.path} replace />;
  }
  return <Navigate to="/perfil" replace />;
};

export default DashboardRedirect;

